import { useState, useCallback, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

interface GalleryData {
  title: string;
  images: string[];
}

const galleryData: Record<string, GalleryData> = {
  'spa-inspired-bathroom': {
    title: 'Spa Inspired Bathroom',
    images: [
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/6a84886da785e8b487aafe8ead2ff217.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/d237593ad07c51f68c7519c3a7c25e3e.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/05e170b8708c4b3a11f51729ffa0b86b.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/8590887df15050e47809b77970828ae6.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/4e384ce406c1276223ca2876167ab0ee.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/68c00d9423c499d3061333b47b59e672.jpeg',
    ],
  },
  'bathroom': {
    title: 'Bathroom',
    images: [
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/1c2d3a9a0855ed058e55a551fdc7f8b1.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/3cc3e099de28809e75ec9db071140bb6.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/b0f25339814bd726673da15f114d27cb.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/77f2c4c2e7c85eed7a6fcadf79e709c8.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/140f7ff1cbac96fc294e9679de2329e5.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/e8c9d8028a625c03e2691bda6e36d56f.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/06a05812b566054061cb0eef8ee53b7b.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/892057c956457b96793c8d92292845b3.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/3151471faf5f6d8c69831629ffbad2b1.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/3528892e0672a8cff06e0376b628e659.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/6fb4feda4436e79c4d4b4b7ced1dc3bf.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/748f74a50e462c95b3e0fd636773e888.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/e02b9ae57bab62de11b8b9cf91ff9059.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/dbb48267527ccff2df04066b57da76ea.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/daa604bf8546c28a93de96f38214b6b0.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/81cf4dddc069d74f3fee52dba1f4abb9.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/8bd9ab5b084b845ba518167c55da6bf4.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/c99c7b4168d404b443c83ec6c267ac27.jpeg',
    ],
  },
  'shower': {
    title: 'Shower',
    images: [
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/bb21d205ccb76c5d7b0ccf06409b203f.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/e27e7682280e2dc0f58ed06abdbed6f5.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/29f9fae28e7a5f39c30390def74d5f17.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/4dfdd22e6d1400f860ed8c745e4aa9ad.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/742eebc816e2d0f1fb94314e2b8642bf.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/bbd1645db457b8f35c143a5d651b873c.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/3151471faf5f6d8c69831629ffbad2b1.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/25a0ad515f7ef0e8a2c49935b8bd27c7.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/61783d851248a0afebbe46dfbae6471b.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/ad8358136feee3a071b01796d81f6821.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/4a2fb2178a9c095f999a5704cdfbf85f.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/9a4b5813af6e1f379c9faacbf2c25781.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/4c8a4631d23b103e4867cb2531bb7ded.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/8ee3f660ee191fc0ef3efc4d67cec614.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/0f3e5a6920ff5c5c1b087bd9afaeb86b.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/5207e3b459a31d9eb889a8b3e96864bd.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/910b68cb12a2cfb88d131ae010bd4e93.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/748f74a50e462c95b3e0fd636773e888.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/3528892e0672a8cff06e0376b628e659.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/f6ff081de16679b97148426074dc7a0b.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/6c35fad7c898de9990bfbeb2f2f721e0.jpeg',
    ],
  },
  'basement': {
    title: 'Basement Renovation',
    images: [
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/471060cbe48f40c3d87e9fca18fb9eeb.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/266dc99e2634664e5651764b42d09789.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/3fd2b3cf836cde93e134d0270a9b776d.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/2d111da8d89852b72a68a0a7bc0850dc.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/3151471faf5f6d8c69831629ffbad2b1.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/6dad5aa29f2d24b561c0de8abc40d849.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/76ce7fcc6c6c5490138a72a5da3807e7.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/0f93480b45ecb5ad3412a6eb9fb8962c.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/6fcebc2e3bea6fe15f4e1454a4bb84da.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/b771ef8945e64c69bb01c6c6335490a5.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/9efbc95bd70c967ae36527596cf66313.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/c67cfb6c5d3a62b57c7d37e7eb6eec98.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/d5b89cd091bc7cc9de987ebd8588b3e3.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/cc7626f6a159c9ae28a00ca3e732c5fa.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/16ca61e1383e7fe93dbc92ffcef9960e.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/e6fdf9a0328eb3100a55e8c68887eb5f.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/19de91cdc207d5325366d4fcb4de13a6.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/8c6d0085f13d5cdd313983e693b30101.jpeg',
    ],
  },
  'kitchen': {
    title: 'Kitchen Renovation',
    images: [
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/1ff0890d8a86c0a5d6918d40918ff275.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/2ebe5ea169b02824a16799ea9979932f.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/daad5f83eba8c824e8beac27e42dba76.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/2e3caf525aaafaf03c090224b306b88d.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/1ef4d6a07d410fb86616ee54176e4b5c.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/6004882e5d82a8ffdbedd3ed1d09455c.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/a43bb772246e39a034767774cda6cbaa.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/7c6b3f1aa316833d548078e36c7979fa.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/dd1b38da1bd82ca6a9602378fa1fda7e.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/6ccf198e047ef42dff3245215ce7ac5d.jpeg',
      'https://public.readdy.ai/ai/img_res/edited_249a185e71688fbfe9631be7442ffee8_89cdcebd.jpg',
      'https://public.readdy.ai/ai/img_res/edited_8565e1f9024b0ba118b5b6b8120cdd78_89cdcebd.jpg',
      'https://public.readdy.ai/ai/img_res/edited_3b034ac291d848d3461eaf850012d222_89cdcebd.jpg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/29dca0bd95431a0ec65f50f02bc80ef8.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/f617a24406b8764fc847c9c58dc1aa0c.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/16e67c346bae8765bf22ee4dc8ff6e50.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/01aab849dc3a2a59df13ef3c5573fefa.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/6e10ac0a7e2d86851f05a0809637cd36.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/f90a5f1cac4447b47c1580096e45c31b.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/51f4dbc92e61c44d4cb1a5f4eba1d7bc.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/bebc46dfdd9a56c74f18f25bc259a4ed.jpeg',
    ],
  },
  'laundry-room': {
    title: 'Laundry Room',
    images: [
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/b771ef8945e64c69bb01c6c6335490a5.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/c736d39e2a1c0ef1007e543a626e7ad8.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/6fcebc2e3bea6fe15f4e1454a4bb84da.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/2d111da8d89852b72a68a0a7bc0850dc.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/654cd73913c51be0d3ebda8b7654948a.jpeg',
      'https://static.readdy.ai/image/a2cbca4593ea5c5c40f1d09622a7bf20/6dad5aa29f2d24b561c0de8abc40d849.jpeg',
    ],
  },
};

interface PhotoCubeProps {
  faceImages: string[];
  title: string;
  speed?: number;
}

const photoCubeStyles = `
@keyframes spinCubeY {
  0%   { transform: rotateX(-18deg) rotateY(0deg); }
  100% { transform: rotateX(-18deg) rotateY(360deg); }
}
.photo-cube-scene {
  perspective: 900px;
}
.photo-cube {
  width: 190px;
  height: 190px;
  position: relative;
  transform-style: preserve-3d;
}
.photo-cube-face {
  position: absolute;
  width: 190px;
  height: 190px;
  overflow: hidden;
  border: 3px solid rgba(255,255,255,0.85);
  border-radius: 6px;
}
.photo-cube-face img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}
.face-front  { transform: translateZ(95px); }
.face-back   { transform: rotateY(180deg) translateZ(95px); }
.face-left   { transform: rotateY(-90deg) translateZ(95px); }
.face-right  { transform: rotateY(90deg) translateZ(95px); }
.face-top    { transform: rotateX(90deg) translateZ(95px); }
.face-bottom { transform: rotateX(-90deg) translateZ(95px); }
`;

function PhotoCube({ faceImages, title, speed = 18 }: PhotoCubeProps) {
  const faces = ['front', 'back', 'left', 'right', 'top', 'bottom'];
  return (
    <div className="photo-cube-scene w-full h-96 flex flex-col items-center justify-center rounded-2xl bg-gradient-to-br from-stone-50 to-stone-100 overflow-hidden">
      <div
        className="photo-cube"
        style={{ animation: `spinCubeY ${speed}s linear infinite` }}
      >
        {faces.map((face, i) => (
          <div key={face} className={`photo-cube-face face-${face}`}>
            <img
              src={faceImages[i % faceImages.length]}
              alt={`${title} cube face ${i + 1}`}
            />
          </div>
        ))}
      </div>
      <p className="mt-8 text-xs font-semibold tracking-widest text-stone-400 uppercase">{title}</p>
    </div>
  );
}

export default function GalleryDetail() {
  const { slug } = useParams<{ slug: string }>();
  const data = slug ? galleryData[slug] : null;

  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  const openLightbox = useCallback((index: number) => {
    setLightboxIndex(index);
  }, []);

  const closeLightbox = useCallback(() => {
    setLightboxIndex(null);
  }, []);

  const goNext = useCallback(() => {
    if (!data) return;
    setLightboxIndex(prev => prev !== null ? (prev + 1) % data.images.length : null);
  }, [data]);

  const goPrev = useCallback(() => {
    if (!data) return;
    setLightboxIndex(prev => prev !== null ? (prev - 1 + data.images.length) % data.images.length : null);
  }, [data]);

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (lightboxIndex === null) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') goNext();
      if (e.key === 'ArrowLeft') goPrev();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [lightboxIndex, closeLightbox, goNext, goPrev]);

  if (!data) {
    return (
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <div className="flex-1 flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Gallery Not Found</h1>
            <Link
              to="/projects"
              className="inline-flex items-center space-x-2 text-teal-600 hover:text-teal-700 font-semibold whitespace-nowrap"
            >
              <i className="ri-arrow-left-line"></i>
              <span>Back to Projects</span>
            </Link>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  const isBathroom = slug === 'bathroom';
  const isShower = slug === 'shower';
  const isSpa = slug === 'spa-inspired-bathroom';
  const isLaundry = slug === 'laundry-room';
  const isKitchen = slug === 'kitchen';
  const isBasement = slug === 'basement';
  const splitIndex = isBathroom ? 15 : isShower ? 18 : isSpa ? 3 : isLaundry ? 3 : isKitchen ? 18 : isBasement ? 15 : -1;
  const firstHalf = (isBathroom || isShower || isSpa || isLaundry || isKitchen || isBasement) ? data.images.slice(0, splitIndex) : data.images;
  const secondHalf = (isBathroom || isShower || isSpa || isLaundry || isKitchen || isBasement) ? data.images.slice(splitIndex) : [];

  const bathroomCubes: { faceImages: string[]; label: string; speed: number }[] = [
    {
      faceImages: [
        data.images[0], data.images[1], data.images[2],
        data.images[3], data.images[4], data.images[5],
      ],
      label: 'Design Details',
      speed: 18,
    },
    {
      faceImages: [
        data.images[4], data.images[5], data.images[6],
        data.images[7], data.images[8], data.images[9],
      ],
      label: 'Craftsmanship',
      speed: 22,
    },
    {
      faceImages: [
        data.images[8], data.images[9], data.images[10],
        data.images[11], data.images[12], data.images[13],
      ],
      label: 'Finishing Touches',
      speed: 14,
    },
  ];

  const showerCubes: { faceImages: string[]; label: string; speed: number }[] = [
    {
      faceImages: [
        data.images[0], data.images[1], data.images[2],
        data.images[3], data.images[4], data.images[5],
      ],
      label: 'Tile Work',
      speed: 20,
    },
    {
      faceImages: [
        data.images[2], data.images[3], data.images[4],
        data.images[5], data.images[6], data.images[7],
      ],
      label: 'Glass & Fixtures',
      speed: 16,
    },
    {
      faceImages: [
        data.images[6], data.images[7], data.images[8],
        data.images[9], data.images[10], data.images[11],
      ],
      label: 'Finished Space',
      speed: 24,
    },
  ];

  const spaCubes: { faceImages: string[]; label: string; speed: number }[] = [
    {
      faceImages: [
        data.images[0], data.images[1], data.images[2],
        data.images[3], data.images[4], data.images[5],
      ],
      label: 'Spa Ambiance',
      speed: 20,
    },
    {
      faceImages: [
        data.images[1], data.images[2], data.images[3],
        data.images[4], data.images[5], data.images[0],
      ],
      label: 'Luxury Details',
      speed: 14,
    },
    {
      faceImages: [
        data.images[2], data.images[3], data.images[4],
        data.images[5], data.images[0], data.images[1],
      ],
      label: 'Serene Design',
      speed: 24,
    },
  ];

  const laundryCubes: { faceImages: string[]; label: string; speed: number }[] = [
    {
      faceImages: [
        data.images[0], data.images[1], data.images[2],
        data.images[0], data.images[1], data.images[2],
      ],
      label: 'Clean Design',
      speed: 18,
    },
    {
      faceImages: [
        data.images[1], data.images[2], data.images[0],
        data.images[2], data.images[0], data.images[1],
      ],
      label: 'Smart Storage',
      speed: 22,
    },
    {
      faceImages: [
        data.images[2], data.images[0], data.images[1],
        data.images[1], data.images[2], data.images[0],
      ],
      label: 'Finished Space',
      speed: 14,
    },
  ];

  const kitchenCubes: { faceImages: string[]; label: string; speed: number }[] = [
    {
      faceImages: [
        data.images[0], data.images[1], data.images[2],
        data.images[3], data.images[4], data.images[5],
      ],
      label: 'Cabinet Design',
      speed: 18,
    },
    {
      faceImages: [
        data.images[3], data.images[4], data.images[5],
        data.images[6], data.images[7], data.images[8],
      ],
      label: 'Countertops',
      speed: 22,
    },
    {
      faceImages: [
        data.images[6], data.images[7], data.images[8],
        data.images[0], data.images[1], data.images[2],
      ],
      label: 'Finishing Touches',
      speed: 14,
    },
  ];

  const basementCubes: { faceImages: string[]; label: string; speed: number }[] = [
    {
      faceImages: [
        data.images[0], data.images[1], data.images[2],
        data.images[3], data.images[4], data.images[5],
      ],
      label: 'Framing & Structure',
      speed: 20,
    },
    {
      faceImages: [
        data.images[3], data.images[4], data.images[5],
        data.images[6], data.images[7], data.images[8],
      ],
      label: 'Finishing Work',
      speed: 16,
    },
    {
      faceImages: [
        data.images[6], data.images[7], data.images[8],
        data.images[9], data.images[10], data.images[11],
      ],
      label: 'Final Result',
      speed: 24,
    },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <style>{photoCubeStyles}</style>
      <Navbar />

      <main className="flex-1 bg-white py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-12">
            <Link
              to="/projects"
              className="inline-flex items-center space-x-2 text-teal-600 hover:text-teal-700 font-semibold mb-6 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              <span>Back to Projects</span>
            </Link>
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              {data.title}
            </h1>
            <p className="text-gray-600 text-xl">Explore Our Work</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {firstHalf.map((image, index) => (
              <div
                key={`first-${index}`}
                className="group relative rounded-2xl overflow-hidden transition-all duration-300 cursor-pointer"
                style={{ boxShadow: image ? '0 4px 16px rgba(0,0,0,0.10)' : undefined }}
                onClick={() => image && openLightbox(index)}
              >
                <div className="relative w-full h-96">
                  {image ? (
                    <>
                      <img
                        src={image}
                        alt={`${data.title} ${index + 1}`}
                        className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
                        <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          <i className="ri-zoom-in-line text-xl text-gray-800"></i>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="w-full h-full flex flex-col items-center justify-center bg-gray-100 border-2 border-dashed border-gray-300 rounded-2xl">
                      <div className="w-12 h-12 flex items-center justify-center mb-3 text-gray-400">
                        <i className="ri-image-add-line text-4xl"></i>
                      </div>
                      <p className="text-gray-400 text-sm font-medium">Photo Coming Soon</p>
                    </div>
                  )}
                </div>
              </div>
            ))}

            {isBathroom && bathroomCubes.map((cube, i) => (
              <PhotoCube
                key={`cube-${i}`}
                faceImages={cube.faceImages}
                title={cube.label}
                speed={cube.speed}
              />
            ))}

            {isShower && showerCubes.map((cube, i) => (
              <PhotoCube
                key={`shower-cube-${i}`}
                faceImages={cube.faceImages}
                title={cube.label}
                speed={cube.speed}
              />
            ))}

            {isSpa && spaCubes.map((cube, i) => (
              <PhotoCube
                key={`spa-cube-${i}`}
                faceImages={cube.faceImages}
                title={cube.label}
                speed={cube.speed}
              />
            ))}

            {isLaundry && laundryCubes.map((cube, i) => (
              <PhotoCube
                key={`laundry-cube-${i}`}
                faceImages={cube.faceImages}
                title={cube.label}
                speed={cube.speed}
              />
            ))}

            {isKitchen && kitchenCubes.map((cube, i) => (
              <PhotoCube
                key={`kitchen-cube-${i}`}
                faceImages={cube.faceImages}
                title={cube.label}
                speed={cube.speed}
              />
            ))}

            {isBasement && basementCubes.map((cube, i) => (
              <PhotoCube
                key={`basement-cube-${i}`}
                faceImages={cube.faceImages}
                title={cube.label}
                speed={cube.speed}
              />
            ))}

            {secondHalf.map((image, index) => (
              <div
                key={`second-${index}`}
                className="group relative rounded-2xl overflow-hidden transition-all duration-300 cursor-pointer"
                style={{ boxShadow: image ? '0 4px 16px rgba(0,0,0,0.10)' : undefined }}
                onClick={() => image && openLightbox(splitIndex + index)}
              >
                <div className="relative w-full h-96">
                  {image ? (
                    <>
                      <img
                        src={image}
                        alt={`${data.title} ${splitIndex + index + 1}`}
                        className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
                        <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          <i className="ri-zoom-in-line text-xl text-gray-800"></i>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="w-full h-full flex flex-col items-center justify-center bg-gray-100 border-2 border-dashed border-gray-300 rounded-2xl">
                      <div className="w-12 h-12 flex items-center justify-center mb-3 text-gray-400">
                        <i className="ri-image-add-line text-4xl"></i>
                      </div>
                      <p className="text-gray-400 text-sm font-medium">Photo Coming Soon</p>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      <Footer />

      {/* Lightbox Modal */}
      {lightboxIndex !== null && (
        <div
          className="fixed inset-0 z-50 flex flex-col bg-black/95"
          onClick={closeLightbox}
        >
          {/* Top bar */}
          <div
            className="flex items-center justify-between px-6 py-4 flex-shrink-0"
            onClick={e => e.stopPropagation()}
          >
            <button
              onClick={closeLightbox}
              className="inline-flex items-center space-x-2 text-white/80 hover:text-white font-semibold transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-left-line text-lg"></i>
              <span className="text-sm tracking-wide">{data.title}</span>
            </button>
            <span className="text-white/50 text-sm font-medium">
              {lightboxIndex + 1} / {data.images.length}
            </span>
            <button
              onClick={closeLightbox}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-close-line text-xl"></i>
            </button>
          </div>

          {/* Image area */}
          <div
            className="flex-1 flex items-center justify-center relative px-16 pb-6 min-h-0"
            onClick={e => e.stopPropagation()}
          >
            <img
              src={data.images[lightboxIndex]}
              alt={`${data.title} ${lightboxIndex + 1}`}
              className="max-w-full max-h-full object-contain rounded-lg"
              style={{ maxHeight: 'calc(100vh - 120px)' }}
            />

            {/* Prev arrow */}
            {data.images.length > 1 && (
              <button
                onClick={goPrev}
                className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/25 text-white transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-arrow-left-s-line text-2xl"></i>
              </button>
            )}

            {/* Next arrow */}
            {data.images.length > 1 && (
              <button
                onClick={goNext}
                className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/25 text-white transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-arrow-right-s-line text-2xl"></i>
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}